import { render, staticRenderFns } from "./KvmLogo.vue?vue&type=template&id=b3d90018&scoped=true&"
import script from "./KvmLogo.vue?vue&type=script&lang=js&"
export * from "./KvmLogo.vue?vue&type=script&lang=js&"
import style0 from "./KvmLogo.vue?vue&type=style&index=0&id=b3d90018&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3d90018",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b3d90018')) {
      api.createRecord('b3d90018', component.options)
    } else {
      api.reload('b3d90018', component.options)
    }
    module.hot.accept("./KvmLogo.vue?vue&type=template&id=b3d90018&scoped=true&", function () {
      api.rerender('b3d90018', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/services/hosting/kvm/KvmLogo.vue"
export default component.exports